import { Link } from 'react-router-dom';
import { Coins, LogOut, Settings, ShoppingBag, User as UserIcon, Bug } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';

/**
 * UserMenu — desktop avatar + coins + dropdown actions for a logged-in user.
 */
export default function UserMenu({ user, onLogout }) {
  return (
    <>
      <div className="flex items-center gap-1.5 glass-light px-3 py-1.5 rounded-full text-sm" data-testid="user-coins">
        <Coins size={14} className="text-yellow-400" />
        <span className="font-semibold text-white">{user.coins}</span>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="flex items-center gap-2 glass-light px-2.5 py-1.5 rounded-full hover:bg-white/10 transition-colors" data-testid="user-menu-trigger">
            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center text-base">{user.avatar}</div>
            <span className="text-sm font-semibold text-white max-w-[100px] truncate">{user.username}</span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass border-white/10 text-white min-w-[180px]" align="end">
          <DropdownMenuLabel className="text-zinc-400 text-xs">Niv. {user.level} • #{user.rank}</DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem asChild className="focus:bg-white/10 cursor-pointer">
            <Link to="/fans" data-testid="menu-profile"><UserIcon size={14} className="mr-2" /> Mon profil</Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild className="focus:bg-white/10 cursor-pointer">
            <Link to="/shop" data-testid="menu-shop"><ShoppingBag size={14} className="mr-2" /> Boutique</Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild className="focus:bg-white/10 cursor-pointer">
            <Link to="/settings" data-testid="menu-settings"><Settings size={14} className="mr-2" /> Paramètres (caméra/micro)</Link>
          </DropdownMenuItem>
          {user.is_founder && (
            <DropdownMenuItem asChild className="focus:bg-white/10 cursor-pointer">
              <Link to="/admin/diagnostics" data-testid="menu-admin-diagnostics">
                <Bug size={14} className="mr-2 text-red-400" /> Auto-Diagnostics
              </Link>
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem onClick={onLogout} className="focus:bg-white/10 cursor-pointer text-pink-400" data-testid="menu-logout">
            <LogOut size={14} className="mr-2" /> Déconnexion
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
